<section class="warranty container-fluid">
    <div class="warranty__content px-3 pb-4 pt-1">
        <div
            class="warranty__content__top d-flex flex-row align-items-center mb-2"
        >
            <img
                [src]="'images/pat-op.svg' | cdn"
                alt="warranty"
                class="warranty__content__top__svg"
            />
            <h2 class="warranty__content__top__text mx-3 my-0">
                {{
                    (isLite
                        ? 'fe_details_step5_warranty_top_lite'
                        : 'fe_details_step5_warranty_top'
                    ) | translate
                }}
            </h2>
        </div>
        <div class="warranty__content__bottom">
            <p class="warranty__content__bottom__text" *ngIf="!isLite">
                {{ 'fe_details_step5_warranty_bottom' | translate }}
            </p>
            <p class="warranty__content__bottom__text" *ngIf="isLite">
                {{ 'fe_details_step5_warranty_bottom_lite' | translate }}
                <a
                    [routerLink]="'coverages-and-protections' | formatUrl"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="warranty__content__bottom__text__href"
                    >{{
                        'fe_details_step5_warranty_bottom_lite_coverages_link' | translate
                    }}</a
                >
            </p>
        </div>
    </div>
</section>
